import i18n from "i18next";

export const truncateText = (text, maxLength) => {
  if (text && text.length > maxLength) {
    return text.slice(0, maxLength) + "...";
  }
  return text;
};

export const formattedStatus = (status) => {
  if (status === "drop_driver") {
    return i18n.t("Drop driver");
  } else if (status === "remove_driver_exchange") {
    return i18n.t("Remove driver exchange");
  } else if (status === "collect") {
    return i18n.t("Collection confirmed");
  } else if (status === "maintenance") {
    return i18n.t("Maintenance");
  } else if (status === "reception_logistic") {
    return i18n.t("Reception");
  } else if (status === "store_logistic") {
    return i18n.t("Stockage");
  } else if (status === "in_use_logistic") {
    return i18n.t("Utilisation");
  } else if (status === "treatment") {
    return i18n.t("Treatment");
  } else {
    return "-";
  }
};

export const formattedColorMaterial = (materialToFormat) => {
  const materialToFormatLower = materialToFormat.toLowerCase().replace("_", "");
  const materialList = JSON.parse(localStorage.getItem("materialsDescription"));

  for (const mat of materialList) {
    if (materialToFormat === "sorting_errors") {
      return "#512e5f";
    }
    if (
      mat.referenceName.toLowerCase().replace("_", "") === materialToFormatLower
    ) {
      return mat?.displayColor;
    }

    for (const possibleName of mat.possibleNames) {
      if (
        possibleName.toLowerCase().replace("_", "") === materialToFormatLower
      ) {
        return mat?.displayColor;
      }
    }
  }

  console.warn(`Color not found for ${materialToFormat}`);
  // return default color
  return "#00a7a6";
};

export const formattedTypeContainer = (type) => {
  if (type === "bigbag") {
    return "Big Bag";
  } else if (type === "ampliroll_bin") {
    return "Benne Ampliroll";
  } else if (type === "chain_bin") {
    return "Benne à chaine";
  } else if (type === "compactor") {
    return "Compacteur";
  } else if (type === "geobox") {
    return "Geobox";
  } else if (type === "intermediate_bulk_container") {
    return "Grand récipient vrac";
  } else if (type === "lattice_box") {
    return "Box grillagé";
  } else if (type === "metallic_drum") {
    return "Fut métalique";
  } else if (type === "plastic_drum") {
    return "Fut plastique";
  } else if (type === "lego") {
    return "Alvéole";
  } else if (type === "housewaste_characterisation_zone") {
    return "Zone de caractérisation OMR";
  } else if (type === "storage_area") {
    return "Zone de stockage";
  } else if (type === "unknown") {
    return "Inconnu";
  } else {
    return "-";
  }
};

export const formattedRoleAddress = (role) => {
  if (role === "client") {
    return "Client";
  } else if (role === "sorting_plant") {
    return "Centre de tri";
  } else if (role === "maintenance_centre") {
    return "Centre de maintenance";
  } else if (role === "building_site") {
    return "Chantier";
  } else if (role === "dump") {
    return "Déchetterie";
  } else if (role === "industrial_site" || role === "industrial") {
    return "Site industriel";
  } else if (role === "landfill_site") {
    return "Centre d'enfouissement";
  } else if (role === "incineration_centre") {
    return "Centre d'incinération";
  } else if (role === "engineering_consultancy") {
    return "Bureau d'études";
  } else {
    return "not status yet";
  }
};

export const formattedError = (error) => {
  if (!error) {
    return "Une erreur est survenue";
  }

  const errorString =
    typeof error === "object" ? error.message || JSON.stringify(error) : error;

  if (errorString === "email_already_exists") {
    return "Cet email est déjà utilisé";
  } else if (errorString === "material_name_waste_already_exists") {
    return "Ce nom du déchet est déjà utilisé";
  } else if (errorString === "missing_required_fields") {
    return "Merci de remplir tous les champs";
  } else if (errorString === "access forbidden") {
    return "Accès refusé";
  } else if (errorString === "invalid password") {
    return "Mot de passe incorrect";
  } else if (errorString === "invalid email") {
    return "Email incorrect";
  } else if (errorString === "content_category_missing") {
    return "Merci de sélectionner une matière";
  } else if (errorString === "invalid_link") {
    return "Lien non valide";
  } else if (
    errorString === "user_not_found" ||
    errorString === "User not found"
  ) {
    return "Utilisateur inexistant";
  } else if (errorString === "expired_link") {
    return "Lien expiré";
  } else if (errorString === "incomplete_address") {
    return "Adresse incomplète : définissez les heures d'ouvertures.";
  } else if (errorString.includes && errorString.includes("role")) {
    return "Rôle non valide : " + errorString;
  } else {
    return "Erreur : " + errorString;
  }
};

export const formattedLevelColor = (
  filling,
  limitFillingLevel,
  type = "normal",
) => {
  const dangerLimitFilling = limitFillingLevel + (limitFillingLevel * 5) / 100;
  const oneQuarterLimitFilling = limitFillingLevel / 4;

  switch (type) {
    case "reverse":
      if (filling >= 0 && filling <= oneQuarterLimitFilling) {
        return "border-solid border-status-red-danger bg-status-red-danger text-status-red-danger";
      } else if (
        filling > oneQuarterLimitFilling &&
        filling < limitFillingLevel
      ) {
        return "border-solid border-status-red bg-status-red text-status-red";
      } else if (filling >= limitFillingLevel && filling < dangerLimitFilling) {
        return "border-solid border-status-orange bg-status-orange text-status-orange";
      } else if (filling >= dangerLimitFilling) {
        return "border-solid border-status-green bg-status-green text-status-green";
      }
      break;

    default:
      if (filling >= 0 && filling <= oneQuarterLimitFilling) {
        return "border-solid border-status-green bg-status-green text-status-green";
      } else if (
        filling > oneQuarterLimitFilling &&
        filling < limitFillingLevel
      ) {
        return "border-solid border-status-orange bg-status-orange text-status-orange";
      } else if (filling >= limitFillingLevel && filling < dangerLimitFilling) {
        return "border-solid border-status-red bg-status-red text-status-red";
      } else if (filling >= dangerLimitFilling) {
        return "border-solid border-status-red-danger bg-status-red-danger text-status-red-danger";
      }

      break;
  }
};

export const formattedLevelBattery = (level) => {
  if (level > 99) {
    return <i className="fas fa-battery-full"></i>;
  } else if (level === 0) {
    return <i className="fas fa-battery-empty"></i>;
  } else if (level > 50 && level <= 99) {
    return <i className="fas fa-battery-three-quarters"></i>;
  } else if (level > 30 && level <= 50) {
    return <i className="fas fa-battery-half"></i>;
  } else if (level > 10 && level <= 30) {
    return <i className="fas fa-battery-quarter"></i>;
  } else if (level > 5 && level <= 10) {
    return <i className="fas fa-battery-empty"></i>;
  } else if (level <= 5) {
    return <i className="fas fa-plug"></i>;
  }
};

export const formattedFillingDelivery = (type, category = "filling") => {
  switch (type) {
    case "critical":
      return category === "map" ? i18n.t("critical_map") : i18n.t("critical");
    case "in_progress":
      return category === "map"
        ? i18n.t("in_progress_map")
        : i18n.t("in_progress");
    case "empty":
      return i18n.t("empty");
    case "light":
      return i18n.t("light");
    case "inactive":
      return i18n.t("inactive");
    case "critical_danger":
      return i18n.t("critical_danger");
    case "all":
      return i18n.t("all");
    default:
      return "";
  }
};

export const formattedFillingDeliveryColor = (type, categorie = "filling") => {
  let result = "";
  switch (type) {
    case "critical":
      result = "#FF1617";
      break;

    case "in_progress":
      if (categorie === "map") {
        result = "#FFBD59";
      } else {
        result = "#00A7A6";
      }
      break;

    case "empty":
      result = "#0F265C";
      break;

    case "light":
      result = "#7ED958";
      break;

    case "critical_danger":
      result = "#AC0001";
      break;

    case "inactive":
      result = "#DBEFBC";
      break;

    case "all":
      result = "#00A7A6";
      break;
    default:
      break;
  }
  return result;
};

export const formattedWasteColor = (waste) => {
  let result = "";
  switch (
    waste
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
  ) {
    case "incinerable":
      result = "#0F265C";
      break;

    case "gravats":
      result = "#00A7A6";
      break;

    case "vegetaux":
      result = "#6CB647";
      break;

    case "encombrant":
      result = "#F9AA00";
      break;

    case "tout-venant":
      result = "#F9AA00";
      break;

    case "carton":
      result = "#E8363B";
      break;

    case "dib":
      result = "#FF006E";
      break;

    case "ferraille a cisailler":
      result = "#48A9A6";
      break;

    case "ferraille e5m":
      result = "#935FA7";
      break;

    case "dechets ultimes":
      result = "#B23A48";
      break;

    case "ferraille":
      result = "#FAB82C";
      break;

    case "bois":
      result = "#2B4B9A";
      break;

    default:
      result = "#0F265C";
      break;
  }
  return result;
};

export const formattedContainerId = (id) => {
  let containerIdPrefix;
  if (id) {
    const strContainer = id.toString();
    const lenContainer = "#000";
    containerIdPrefix = lenContainer.substring(
      0,
      lenContainer.length - strContainer.length,
    );
  } else {
    containerIdPrefix = "...";
  }

  return containerIdPrefix;
};

export const toFrenchNumber = (number, decimalPlaces) => {
  return number?.toLocaleString("fr-FR", {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  });
};

export const getShortIdPart = (id) => {
  const suffix = "_l";
  const suffixIndex = id.lastIndexOf(suffix);

  if (suffixIndex !== -1) {
    const idBeforeSuffix = id.slice(0, suffixIndex);
    return idBeforeSuffix.slice(-5);
  }

  return id;
};
